import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  sellerFlashSalesTag: {
    id: 'product_page_seller_flash_sales_tag',
    defaultMessage: 'Price drop',
  },
} as Record<string, I18nDefinition>
